export const useOcApi = () => {
  const customApiUrl = process.env.REACT_APP_API_URL;

  let apiUrl = `http://${window.location.hostname}:9000/api`;
  let graphqlUrl = `http://${window.location.hostname}:9000/graphql`;
  let wsUrl = `ws://${window.location.hostname}:9000/graphql`;

  if (customApiUrl) {
    apiUrl = `${customApiUrl}/api`;
    graphqlUrl = `${customApiUrl}/graphql`;
    const wsProtocol = customApiUrl.startsWith("https") ? "wss" : "ws";
    const wsHost = customApiUrl.replace(/^https?:\/\//, "");
    wsUrl = `${wsProtocol}://${wsHost}/graphql`;
  } else if (process.env.NODE_ENV === "production") {
    apiUrl = "/api";
    graphqlUrl = "/graphql";
    const wsProtocol = window.location.protocol === "https:" ? "wss" : "ws";
    wsUrl = `${wsProtocol}://${window.location.host}/graphql`;
  }

  const uploadUrl = `${apiUrl}/upload`;

  return { apiUrl, wsUrl, graphqlUrl, uploadUrl };
};

export default useOcApi;
